import { ProjectSummaryMapper } from '../mapper/ProjectSummaryMapper';

export const projectSummaryMapper = new ProjectSummaryMapper();
